import { withLayout } from 'layouts';
import Failed from './failed.component';
import Success from './success.component';

export const PaymentSuccessCallback = withLayout(Success);
export const PaymentFailedCallback = withLayout(Failed);
